function occupancy_graph_Reducer(state = null, action) {
    switch (action.type) {
        case 'OCCUPANCY_GRAPH/SET':
            return action.data;
        case 'OCCUPANCY_GRAPH/CLEAR':
            return null;
        default: return state;
    }
}

export default occupancy_graph_Reducer;
